import { POSTERS_BASE_URL } from "@/assets.js";

const posters = [

    {
        venue: "BRAIN Investigators Meeting, 2023.",
        title: "Looking Forward with BossDB: Modern Metadata Solutions, Dynamic Graph Querying, and Streamlined Ingest for Volumetric and Connectomics Datasets",
        authors: "Gooden et al",
        link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2023 Brain Investigators Meeting - Poster - Looking Forward with BossDB.pdf")}`,
        thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2023 Brain Investigators Meeting - Poster - Looking Forward with BossDB.png")}`,
},  {
        venue: "BRAIN Investigators Meeting, June 2021.",
        title: "Single-button import of cloud-stored volumetric data into virtual reality enhances data access & exploration",
        authors: "Michael et al",
        link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - syGlass+BossDB.pdf")}`,
        thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - syGlass+BossDB.png")}`,
}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/2021+Brain+Investigators+Meeting+-+Poster+-+SABER.pdf",
    "venue": "BRAIN Investigators Meeting, June 2021.",
    "title": "A Web-Based Portal for Workflow Deployment to Enhance the Scalable Analytics for Brain Exploration Research (SABER) System",
    "authors": "Xenes et al",
    link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - SABER.pdf")}`,
    thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - SABER.png")}`,
}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/2021+Brain+Investigators+Meeting+-+Poster+-+Ventana.pdf",
    "venue": "BRAIN Investigators Meeting, June 2021.",
    "title": "A Quality Compute Engine for the Automatic Assessment of Connectome Data",
    "authors": "Villafañe-Delgado et al",
    link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - Ventana.pdf")}`,
    thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - Ventana.png")}`,
}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/2021+Brain+Investigators+Meeting+-+Poster+-+CIRCUIT+STEM.pdf",
    "venue": "BRAIN Investigators Meeting, June 2021.",
    "title": "Effective recruiting of trailblazing early-career STEM leaders through holistic selection and scientific mentorship",
    "authors": "Cervantes et al",
    link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - CIRCUIT STEM.pdf")}`,
    thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - CIRCUIT STEM.png")}`,

}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/2021+Brain+Investigators+Meeting+-+Poster+-+Building+Invariances.pdf",
    "venue": "BRAIN Investigators Meeting, June 2021.",
    "title": "Building invariances into neural decoding through adaptive self-alignment",
    "authors": "Dyer et al",
    link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - Building Invariances.pdf")}`,
    thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - Building Invariances.png")}`,

}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/2021+Brain+Investigators+Meeting+-+Poster+-+BossDB.pdf",
    "venue": "BRAIN Investigators Meeting, June 2021.",
    "title": "bossDB: A scalable, highly accessible data archive for electron microscopy and X-ray microtomograph",
    "authors": "Hider et al",
    link: `${POSTERS_BASE_URL}pdfs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - BossDB.pdf")}`,
    thumb: `${POSTERS_BASE_URL}pngs/${encodeURIComponent("2021 Brain Investigators Meeting - Poster - BossDB.png")}`,

}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/2021+Brain+Investigators+Meeting+-+Poster+-+syGlass%2BBossDB.pdf",
    "venue": "BRAIN Investigators Meeting, June 2021.",
    "title": "syGlass + bossDB: serving cloud-based volumetric data to local virtual reality devices for exploration, insight, and communication",
    "authors": "Morehead et al",
},  {
    // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_calabresi_celltypes.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "Generative and Discriminative Approaches for Neuronal Cell Type",
    "authors": "Calabresi et al",
}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_cervantes_circuit_final.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "CIRCUIT: Cohort-based Integrated Research Community for Undergraduate Innovation and Trailblazing",
    "authors": "Cervantes et al",
}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_cowley_navigate.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "NAVIGATE: Neuroanatomical validation of MR-based Connectomes",
    "authors": "Cowley et al",
}, {
    // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_downs_largegraphs.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "Rapid and Scalable Connectome Reconstruction Assessment through Graph Analytics",
    "authors": "Downs et al",
}, {
   // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_johnson_transferlearning.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "Transfer Learning Analysis of Computer Vision Tools for Automated Analysis of Neuron and Synapse Connectivity in Electron Microscopy Data",
    "authors": "Johnson et al",
}, {
   // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_matelsky_dotmotif.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "DotMotif: Subgraph isomorphisms on large brain graphs",
    "authors": "Matelsky et al",
}, {
   // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_matson_smart.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "SMART: Statistical Method for Annotation Reconstruction from Traces",
    "authors": "Matson et al",
}, {
   // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_normantenazas_worminator.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "Training a neural model using the C. elegans connectome to perform exploration tasks",
    "authors": "Norman-Tenazas et al",
}, {
   // "link": "https://publications-and-posters.s3.amazonaws.com/sfn2019_reilly_probmotifs_final.pdf",
    "venue": "Society for Neuroscience, Chicago, USA. November 2019.",
    "title": "A method for repeated neural circuit identification in noisy brain graph data",
    "authors": "Reilly et al",
},
];

export default posters;
